import { createFileRoute, useRouter } from '@tanstack/react-router';

import { useAuth } from '@/app/providers/AuthProvider';
import { ForgotPasswordForm } from '@/features/authentication/ForgotPasswordForm';
import { AuthenticationLayout } from '@/layouts/AuthenticationLayout';

function ChangePasswordPage() {
  const router = useRouter();
  const { admin } = useAuth();

  return (
    <AuthenticationLayout
      title="Change Password"
      description="For security, we'll send a single-use reset link to your administrator email address."
      onBack={() => router.history.back()}
    >
      {admin === null ? null : (
        <ForgotPasswordForm defaultEmail={admin.email} lockEmail showSignInLink={false} />
      )}
    </AuthenticationLayout>
  );
}

export const Route = createFileRoute('/admin/change-password')({
  component: ChangePasswordPage,
});
